import { writeCellBind, type DirectoryCell } from './cell-bind';

export const GENERIC_INVALID_ACCESS_CODE = 'Invalid access code';

export async function resolveAccessCode(accessCode: string): Promise<DirectoryCell> {
  const base = import.meta.env.VITE_CELL_DIRECTORY_URL?.replace(/\/$/, '');
  if (!base) throw new Error(GENERIC_INVALID_ACCESS_CODE);
  const res = await fetch(`${base}/v1/actions/resolve-code`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ access_code: accessCode }),
  });
  if (!res.ok) throw new Error(GENERIC_INVALID_ACCESS_CODE);
  return (await res.json()) as DirectoryCell;
}

export async function bindGlobalCellFromCode(accessCode: string): Promise<DirectoryCell> {
  const cell = await resolveAccessCode(accessCode);
  writeCellBind({ cell, access_code: accessCode });
  return cell;
}
